import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import { Typography, Card, Spin, DatePicker, Input, Row, Col, Select, Form } from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const AddGLA0800 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const { TextArea } = Input;
  const { newEndOfCirclesItems } = appStatic;
  const { accountClosure, branch, closingDate, comments, pleaseEnter } = appLabel;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [officeData, setOfficeData] = useState([]);
  const [endOfCircleList, setEndOfCircleList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [EndOfCircleDetail, setEndOfCircleDetail] = useState([]);

  useEffect(() => {
    getOfficeListAction();
    getClosureAction();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  const getOfficeListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        // console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  };

  const getClosureAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetEndOfCircles, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            branch: element?.officeName,
            accountingclosuredate: element?.closingDate ? element?.closingDate : "-",
            comments: element?.comments ? element?.comments : "-",
            closeAccountingCreatedBy: element?.createdByUsername,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setEndOfCircleList(tempArray.filter((item) => item.disabled === false));
        setEndOfCircleList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getClosureById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.GetEndOfCircle}=${params.value}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objDetail = res;
        setEndOfCircleDetail(objDetail[0]);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/gla0800", { replace: false });
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    // console.log(objParam);
    getClosureById(objParam);
  };

  const onSubmit = (formValues) => {
    const originalDate = new Date(formValues.closingDate);
    const day = originalDate.getDate();
    const month = new Intl.DateTimeFormat("en", { month: "long" }).format(originalDate);
    const year = originalDate.getFullYear();
    const formattedDate = `${day} ${month} ${year}`;

    formValues.closingDate = formattedDate;

    const body = {
      ...formValues,
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewEndOfCircle,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newEndOfCircleCreatedMsg);
          navigate("/gla0800");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0800");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent pageTitle={accountClosure} pageItems={newEndOfCirclesItems} />
      <Spin spinning={isLoading} size="large">
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={
              <Title level={4} style={{ color: "#000" }}>
                {appLabel.accountClosureSetup}
              </Title>
            }
          >
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Col span={8}>
                  <Form.Item
                    name="officeId"
                    label={<Text style={{ fontSize: "16px" }}>{branch}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(branch),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(branch)}
                      style={{ width: "30vh" }}
                      showSearch
                      options={officeData}
                      onChange={onSelectItemAction}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="closingDate"
                    label={<Text style={{ fontSize: "16px" }}>{closingDate}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(closingDate),
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder={BOM.handlePlaceholderMsg(closingDate)}
                      style={{ width: "30vh" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="comments"
                    label={<Text style={{ fontSize: "16px" }}>{comments}</Text>}
                  >
                    <TextArea
                      placeholder={BOM.handlePlaceholderMsg(comments, pleaseEnter)}
                      showCount
                      maxLength={100}
                      style={{
                        height: 120,
                        resize: "none",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                {BOM.HasPermission("CREATE_GLCLOSURE") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#92428B"
                    colorText="white"
                    hoverBackground="#AD4EA7"
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Card>
        </Form>
        {/* </Card> */}
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddGLA0800);
